import React from 'react';

import { clearCache, createIcon, getCommonImage, itemdc6, makeBitmap } from 'graphics';
import { hd_clearCache, hd_createIcon, hd_getCommonImage, hd_itempng, hd_makeBitmap } from 'hdgraphics';
import { PD2, PTR } from 'common';

export const legacyGraphics = {
  itemdc6: itemdc6,
  makeBitmap: makeBitmap,
  createIcon: createIcon,
  getCommonImage: getCommonImage,
  clearCache: clearCache,
};
export const hdGraphics = {
  hd: true,
  itemdc6: hd_itempng,
  makeBitmap: (src, tint, frameList) => hd_makeBitmap(src, tint, src?.width > 1000 ? 48 : null, frameList), // very hax
  createIcon: hd_createIcon,
  getCommonImage: hd_getCommonImage,
  clearCache: hd_clearCache,
};

export const GameVersions = {
  lod: {
    name: 'lod',
    gfx: legacyGraphics,
    inventory: {
      rows: 4,
      columns: 10,
    },
    cube: {
      rows: 4,
      columns: 3,
    },
    gridSize: 29,
    options: {
      etherealBug: true,
    },
  },
  pd2: {
    name: 'pd2',
    suffix: true,
    gfx: legacyGraphics,
    inventory: {
      rows: 8,
      columns: 10,
    },
    cube: {
      rows: 4,
      columns: 4,
    },
    gridSize: 29,
    charmRows: 4,
    options: {
      etherealBug: true,
    },
  },
  d2r: {
    name: 'd2r',
    gfx: hdGraphics,
    inventory: {
      rows: 4,
      columns: 10,
    },
    cube: {
      rows: 4,
      columns: 3,
    },
    gridSize: 30,
    options: {
      etherealBug: false,
    },
  },
  ptr: {
    name: 'd2r',
    suffix: true,
    gfx: hdGraphics,
    inventory: {
      rows: 4,
      columns: 10,
    },
    cube: {
      rows: 4,
      columns: 3,
    },
    gridSize: 30,
    options: {
      etherealBug: false,
      setUpgrade: true,
    },
  },
};

const GameContext = React.createContext(GameVersions.d2r);

export default GameContext;
